<template>
  <div>
    <!-- 电脑版导航栏 -->
    <div class="NavbarBox1">
      <div class="navbar1Title">
          <img src="@/assets/img/logo.png" @click="goHome"  class="logo" />
        <div>
          <div class="logoBox">
            <div>
              <el-autocomplete
                prefix-icon="el-icon-search"
                class="searchBox"
                v-model="searchText"
                placeholder="Find Products"
                popper-class="my-autocomplete"
                :fetch-suggestions="querySearch"
                :debounce="300"
                :trigger-on-focus="true"
                @select="handleSearchSelect"
              >
              <div slot="suffix" class="searchIcon" @click="handleIconClick">
                Search
              </div>
              <template slot-scope="{ item }">
                <div v-if="item.isHotPanel" class="hot-search-panel" @mousedown.stop.prevent>
                  <div class="hot-search-title">Hot Searches</div>
                  <div class="hot-search-tags">
                    <span
                      v-for="tag in hotSearchTags"
                      :key="tag"
                      class="hot-search-tag"
                      @mousedown.stop.prevent="handleHotTagClick(tag)"
                    >{{ tag }}</span>
                  </div>
                </div>
                <div v-else class="search-suggestion-item">
                  <img class="search-suggestion-img" :src="httpUrl + '/' + item.productImg" :alt="item.productName">
                  <span class="search-suggestion-name">{{ item.productName }}</span>
                </div>
              </template>
            </el-autocomplete>
            </div>
            <div class="logoRightBox">
              <i class="el-icon-user" @click="handleLogin"></i>
              <div ref="cartRef">
                <el-badge v-show="isLogin && catNum>0" :value="catNum" class="badge">
                  <img src="@/assets/fonts/bagWhite.svg" @click="toCart()" alt="">
                </el-badge>
                <img v-show="!isLogin || catNum==0" src="@/assets/fonts/bagWhite.svg" @click="toCart()" alt="">
                </div>
              <img class="collImg" src="@/assets/fonts/LoveWhite.svg" @click="toMyCenter()" alt="">
            </div>
          </div>
          <div class="pcMenuBox" @mouseleave="pcMenuOut">
            <div class="pcMenu" >
              <div v-for="item in FixedTitle" @click="toRoute(item)" :key="item.id" 
              @mouseenter="pcMenuHover(item.menuName)" :class="hoverMenu==item.menuName?'actionMenu':''">
                <svg v-show="item.showIcon" t="1740624986446" class="icon homeIcon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9196" width="256" height="256"><path d="M170.666667 298.666667a42.666667 42.666667 0 0 1 42.666666-42.666667h597.333334a42.666667 42.666667 0 1 1 0 85.333333H213.333333a42.666667 42.666667 0 0 1-42.666666-42.666666z m0 213.333333a42.666667 42.666667 0 0 1 42.666666-42.666667h597.333334a42.666667 42.666667 0 1 1 0 85.333334H213.333333a42.666667 42.666667 0 0 1-42.666666-42.666667z m0 213.333333a42.666667 42.666667 0 0 1 42.666666-42.666666h597.333334a42.666667 42.666667 0 1 1 0 85.333333H213.333333a42.666667 42.666667 0 0 1-42.666666-42.666667z" 
                  :fill="hoverMenu===item.menuName?'#000000':'#fff'" p-id="9197"></path></svg>
                  <img class="hotIcon" src="@/assets/fonts/hot.svg" v-show="item.showHotIcon" alt="">

                <div :class="nowTitle===item.path?'nowTitle':''" >{{ item.menuName }}</div>

                <i v-if="item.showMore" class="el-icon-arrow-down"></i>
              </div>
              <!-- <div @mouseenter="pcMenuHover('Accueil')"  :class="hoverMenu=='Accueil'?'actionMenu':''">
                <i class="el-icon-s-home homeIcon"></i>
                <div>Accueil</div>
                <i class="el-icon-arrow-down"></i>
              </div>
              <div @mouseenter="pcMenuHover('YJZ Products')" :class="hoverMenu=='YJZ Products'?'actionMenu':''">
                <div>YJZ Products</div>
                <i class="el-icon-arrow-down"></i>
              </div>
              <div @mouseenter="pcMenuHover('About Us')" :class="hoverMenu=='About Us'?'actionMenu':''">About Us</div>
              <div @mouseenter="pcMenuHover('Contact Us')" :class="hoverMenu=='Contact Us'?'actionMenu':''">Contact Us</div>
              <div @mouseenter="pcMenuHover('Blog')" :class="hoverMenu=='Blog'?'actionMenu':''">Blog</div>
              <div @mouseenter="pcMenuHover('Shipping & Policies')" :class="hoverMenu=='Shipping & Policies'?'actionMenu':''">Shipping & Policies</div> -->
            </div>
            <div v-show="showMoreMenu">
              <!-- Accueil下拉菜单 -->
              <!-- <div v-show="hoverMenu=='Accueil'" class="menuBodyBox">
                <div class="menuBodyLeftBox">
                  <div @mouseenter="pcMenuTwoHover(item)" class="menuBodyLeftItem" v-for="item in showMoreLeftList" :key="item.code">
                    <div>{{ item.name }}</div>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="menuBodyRightBox">
                  <div class="menuAccueliBox">
                    <div class="menuAccueliTitle">{{ 'View more '+moreTwoTitle }}</div>
                    <div class="menuAccueliItemBox">
                      <ProductItem :item="item" v-for="(item,index) in showMoreRightList" :key="index"/>
                    </div>
                  </div>
                </div>
              </div> -->
              <div v-show="hoverMenu=='Shopping'" class="menuBodyBox">
                <div class="menuBodyLeftBox">
                  <div v-for="(item,index) in showMoreLeftList" @click="goProductList(item)" @mouseenter="pcMenuTwoHover(item,index)" class="menuBodyLeftItem"  :key="item.id">
                    
                    <div>{{ item.menuName }}</div>
                    <i v-show="item.children && item.children.length>0" class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="menuBodyProductsBox">
                  <div v-if="showMoreLeftList.length>0 && 
                  showMoreLeftList[this.showMoreProductsIndex].children && 
                  showMoreLeftList[this.showMoreProductsIndex].children.length > 0">
                    <div v-for="item in showMoreLeftList[this.showMoreProductsIndex].children" @click="goProductList(item)" :key="item.id" >
                        <div v-show=" item.children.length<=0" class="menuBodyProductsTitle" >{{ item.menuName }}</div>
                        <div v-if="item.children && item.children.length>0">
                          <div v-show=" item.children.length>0" class="menuBodyProductsTitle">{{ item.menuName }}</div>
                          <div class="menuBodyProductsPath" v-for="child in item.children" :key="child.id" @click="goProductList(child)" >
                            {{ child.menuName }}
                          </div>
                        </div>
                    </div>
                  </div>

                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机版导航栏 -->
    <div class="NavbarBox2">
      <div class="Navbar2Title"  :class="{ 'Navbar2MenuShow': showMenu, 'Navbar2MenuHide': !showMenu }">
        <div  class="el-icon-s-fold Navbar2MenuBox" @click="handleShowMenu"/>
        <img @click="goHome" src="@/assets/img/logo.png" class="logo" to="/"/>
        <img src="@/assets/fonts/search.svg" @click="showSearch=!showSearch"  class="search"/>
      </div>


      <div class="searchBox mobile-searchBox" v-show="showSearch">
        <el-autocomplete
          v-model="searchText"
          placeholder="Find Products"
          popper-class="my-autocomplete"
          :fetch-suggestions="querySearch"
          :debounce="300"
          :trigger-on-focus="true"
          @select="handleSearchSelect"
        >
          <template slot-scope="{ item }">
            <div v-if="item.isHotPanel" class="hot-search-panel" @mousedown.stop.prevent>
              <div class="hot-search-title">Hot Searches</div>
              <div class="hot-search-tags">
                <span
                  v-for="tag in hotSearchTags"
                  :key="tag"
                  class="hot-search-tag"
                  @mousedown.stop.prevent="handleHotTagClick(tag)"
                >{{ tag }}</span>
              </div>
            </div>
            <div v-else class="search-suggestion-item">
              <img class="search-suggestion-img" :src="httpUrl + '/' + item.productImg" :alt="item.productName">
              <span class="search-suggestion-name">{{ item.productName }}</span>
            </div>
          </template>
        </el-autocomplete>
        <el-button size="mini" @click="handleIconClick" type="primary">search</el-button>
      </div>
      <div class="menuBox" v-show="showMenu">
        <div class="menuLogoBox">
          <img src="@/assets/img/logo.png" class="logo" to="/"/>
        </div>
        <el-menu   unique-opened class="el-menu-vertical-demo" active-text-color="#909399"
        @select="handleSelect" @close="handleClose" :collapse="false">
          <MenuTreeMb v-for="item in FixedTitle" :key="item.id" :menu="item"/>
          <!-- <div v-for="item in titleList" :key="item.code">
            <el-submenu :index="item.code" v-if="item.children.length>0">
              <template slot="title">
                <i class="el-icon-success"></i>
                <span slot="title">{{ item.name }}</span>
              </template>
              <el-menu-item :index="item1.code" v-for="item1 in item.children" :key="item1.code" >
                <i class="el-icon-arrow-right"></i>
                <span slot="title">{{ item1.name }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item :index="item.code" v-if="item.children.length<1">
              <i class="el-icon-success"></i>
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </div> -->
        </el-menu>
        <div class="menuBottomBox">
          <div @click="handleLogin">
            <div class="el-icon-user"></div>
            <div>{{ !isLogin?'Login':'Account' }}</div>
          </div>
          <div class="menuBottomItem">
            <div @click="toCart">
              <div class="el-icon-shopping-cart-2 menuBottomIcon"></div>
              <div>Cart</div>
            </div>
            <div @click="toColl">
              <div class="el-icon-star-off menuBottomIcon"></div>
              <div>Collection</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 遮罩层 -->
      <div class="masklayerBox" @click="handleShowMenu" v-show="showMenu"/>
    </div>
    <AppMain v-if="isDataLoaded" class="appMainBox" ref="AppMain"/>
    <Login  ref="Login"/>
  </div>
</template>

<script>
import Login from '@/components/Login'
import AppMain from './AppMain.vue'
import MenuTreePc from './MenuTreePc.vue';
import MenuTreeMb from './MenuTreeMb.vue';
import ProductItem from '../ProductItem.vue';
import { GetMenuList, SearchProducts } from '@/api/products'
import { HTTP_API } from '@/assets/js/conSysUrl'

export default {
  name: 'Navbar',
  components: {
    Login,
    AppMain,
    MenuTreePc,
    MenuTreeMb,
    ProductItem
  },
  data () {
    return {
      FixedTitle : [
        // {
        //   id: 1,
        //   name: 'Accueil',
        //   showIcon: true,
        //   showMore: true,
        //   path: '/',
        // },
        {
          id: -10,
          menuName: 'Shopping',
          showIcon: true,
          showMore: true,
          path: '/products',
          children:[],
        },
        {
          id: -15,
          menuName: '​​Project Kits​',
          showIcon: false,
          showHotIcon: true,
          showMore: false,
          path: '/hotKit',
        },
        {
          id: 11,
          menuName: 'About Us',
          showIcon: false,
          showMore: false,
          path: '/aboutUs',
        },
        {
          id: -12,
          menuName: 'Contact Us',
          showIcon: false,
          showMore: false,
          path: '/contact',
        },
        {
          id: -13,
          menuName: 'Blog',
          showIcon: false,
          showMore: false,
          path:'/blog'
        },
        {
          id: -14,
          menuName: 'Shipping & Policies',
          showIcon: false,
          showMore: false,
          path: '/shipping',
        },
      ],
      searchText: '',
      httpUrl: HTTP_API,
      hotSearchTags: ['relay', 'esp32', '18650', 'NANO', 'led', 'switch', 'esp8266', 'motor'],
      pcSearch:false,
      showSearch: false,
      showMenu: false,
      windowWidth: 0,
      pcMenuList: {
      },
      isDataLoaded:false,
      productList: {
        "Latest news": [
          // {
          //   title:"LCD1602 LCD2004 IIC/I2C Interface PCF8574 Expansion Board",
          //   price:0.25,
          //   img:"https://www.jh-electronica.com/UserFiles/upload/image/20211129/YXB315.jpg",
          // },
          // {
          //   title:"LCD1602 LCD2004 IIC/I2C Interface PCF8574 Expansion Board",
          //   price:0.25,
          //   img:"https://www.jh-electronica.com/UserFiles/upload/image/20211129/YXB315.jpg",
          // },
          // {
          //   title:"LCD1602 LCD2004 IIC/I2C Interface PCF8574 Expansion Board",
          //   price:0.25,
          //   img:"https://www.jh-electronica.com/UserFiles/upload/image/20211129/YXB315.jpg",
          // },
          // {
          //   title:"LCD1602 LCD2004 IIC/I2C Interface PCF8574 Expansion Board",
          //   price:0.25,
          //   img:"https://www.jh-electronica.com/UserFiles/upload/image/20211129/YXB315.jpg",
          // },
          // {
          //   title:"LCD1602 LCD2004 IIC/I2C Interface PCF8574 Expansion Board",
          //   price:0.25,
          //   img:"https://www.jh-electronica.com/UserFiles/upload/image/20211129/YXB315.jpg",
          // },
          // {
          //   title:"LCD1602 LCD2004 IIC/I2C Interface PCF8574 Expansion Board",
          //   price:0.25,
          //   img:"https://www.jh-electronica.com/UserFiles/upload/image/20211129/YXB315.jpg",
          // },
          // {
          //   title:"LCD1602 LCD2004 IIC/I2C Interface PCF8574 Expansion Board",
          //   price:0.25,
          //   img:"https://www.jh-electronica.com/UserFiles/upload/image/20211129/YXB315.jpg",
          // },
          // {
          //   title:"LCD1602 LCD2004 IIC/I2C Interface PCF8574 Expansion Board",
          //   price:0.25,
          //   img:"https://www.jh-electronica.com/UserFiles/upload/image/20211129/YXB315.jpg",
          // },
        ],
        "Our most recommended": [
          // {
          //   title:"MEGA2560 R3 CH340G Development Board",
          //   price:0.55,
          //   img:"https://www.jh-electronica.com/UploadFiles/YXC103-1.jpg",
          // }
        ],
      },
      hoverMenu: '',
      showMoreMenu: false,
      moreTwoTitle: '',//二级菜单标题
      showMoreLeftList:[],
      showMoreRightList: [],
      showMoreProductsIndex: 0,
      nowTitle: "",
    }
  },
  watch: {
    '$route'(to, from) {
      const arr = this.FixedTitle.find(item => item.path === to.path)
      if (arr) {
        this.nowTitle = arr.path
      } else {
        this.nowTitle = ''
      }

    }
  },
  created() {
    //使用浏览器缓存
    // localStorage.setItem('pcMenuList', JSON.stringify(this.pcMenuList))
    this.getMenuList()
    if (this.isLogin) {
      this.$store.dispatch('getCarNum')
    }
    document.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown)
  },
  computed: {
    isLogin() {
      return this.$store.state.token ? true : false
    },
    catNum() {
      return this.$store.state.carNum
    }
  },
  methods: {
    handleKeyDown(e) {
      if (e.keyCode === 13 && this.searchText) {
        this.handleIconClick();
      }
    },
    getTreeData(data, pid) {
      let treeData = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].parentId == pid) {
          let obj = data[i]
          obj.children = this.getTreeData(data, data[i].id)
          treeData.push(obj)
        }
      }
      return treeData
    },
    getMenuList() {
      GetMenuList().then(res => {
        const arr = res.data.filter(item=> item.hidden === 0)
        this.pcMenuList.Shopping = this.getTreeData(arr, 0)[0].children
        sessionStorage.setItem('menuList', JSON.stringify(this.pcMenuList))
        this.isDataLoaded= true
        // this.FixedTitle[0].children = this.pcMenuList.Shopping
      }).catch(err => {
        
      })

    },
    //跳转商品列表
    goProductList(item) {
      event.stopPropagation();

      this.pcMenuOut()
      // window.scrollTo({ top: 0, behavior: 'auto' });
      //获取当前路由
      // let currentRoute = this.$route.path
      // if (currentRoute === '/products') return
      this.$router.push({
        path: '/products',
        force: true,
        query: {
          id: item.id,
          name: item.menuName
        },
      })
      

    },
    pcMenuTwoHover(item,index) {
      if (this.hoverMenu === "Accueil") {
        this.showMoreRightList = this.productList[item.name]
        this.moreTwoTitle = item.name
        
      } else if (this.hoverMenu === "Shopping") {
        this.showMoreProductsIndex = index
      }
    },
    toCart() {
      this.showMenu = false
      if (this.isLogin) {
        this.$router.push('/shopCart')
        return
      }
      this.$refs.Login.show()
    },
    toColl() {
      this.showMenu = false
      if (this.isLogin) {
        this.$router.push('/userCenter')
        return
      }
      this.$refs.Login.show()
    },
    goHome() {
      this.$router.push('/')
    },
    toMyCenter() {
      if (this.isLogin) {
      this.$router.push('/userCenter')
        return
      }
      this.$refs.Login.show()
      this.showMenu = false
    },
    toRoute(item) {
      //获取当前的路由
      // let currentRoute = this.$route.path
      // if (currentRoute === item.path) return
      this.pcMenuOut()
      
      
      this.$router.push({
        path: item.path
      })
    },
    pcMenuHover(item) {
      this.hoverMenu = item
      if (this.pcMenuList[item]) {
        this.showMoreLeftList = this.pcMenuList[item]
        this.showMoreMenu = true
      }
    },
    pcMenuOut() {
      this.showMoreMenu = false
      this.showMoreLeftList =[]
      this.showMoreRightList =[]
      this.hoverMenu = ''
    },
    //点击搜索图片
    handleIconClick() {
      if(!this.searchText) return
      this.$router.push({ path: '/products', query: { keywords: this.searchText } })
      this.showSearch = false
    },
    handleHotTagClick(tag) {
      const route = this.$router.resolve({ path: '/products', query: { keywords: tag } })
      window.open(route.href, '_blank')
      this.searchText = ''
      this.showSearch = false
      this.blurSearchInput()
    },
    blurSearchInput() {
      this.$nextTick(() => {
        document.querySelectorAll('.searchBox .el-input__inner').forEach((el) => el.blur())
      })
    },
    async querySearch(queryString, cb) {
      const keyword = (queryString || '').trim()
      if (!keyword) {
        cb([{ value: '__hot__', isHotPanel: true }])
        return
      }
      try {
        const { status, data } = await SearchProducts(keyword)
        if (status && data && data.length) {
          cb(data.map(item => ({
            ...item,
            value: item.productName,
          })))
        } else {
          cb([])
        }
      } catch (error) {
        cb([])
      }
    },
    handleSearchSelect(item) {
      if (!item || item.isHotPanel) {
        this.searchText = ''
        return
      }
      if (!item.id) return
      this.$router.push({ path: '/productDetail', query: { id: item.id } })
      this.searchText = ''
      this.showSearch = false
    },
    goHome() {
      if(this.$route.path === '/') return
      this.$router.push('/')
    },
    handleShowMenu() {
      this.showMenu = !this.showMenu
    },
    handleSelect(key, keyPath) {
      const url = this.FixedTitle.filter(item => item.id == key)[0].path
      if (url) {
        this.showMenu = false
        this.$router.push(url)
      }
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleLogin() {
      this.showMenu = false
      if (this.isLogin) {
        this.$router.push('/userCenter')
        return
      }
      this.$refs.Login.show()
    },
  }
}
</script>

<style scoped lang="scss">
.badge{
  ::v-deep{
    .el-badge__content {
      line-height:16px;
    }
  }
  // margin-top: 10px;
  // margin-right: 40px;
}
//移动
@media screen and (max-width: 1024px) {
  .NavbarBox1{
    display: none;
  }
  .NavbarBox2{
    .masklayerBox{
      width: 100%;
      height: 750%;
      background: #000;
      opacity: .3;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 800;
    }
    .Navbar2MenuShow{
      transform: translateX(60%);
      //过渡动画
      transition: all 0.5s ease;
    }
    .Navbar2MenuHide{
      transform: translateX(0);
      //过渡动画
      transition: all 0.5s ease;
    }
    .Navbar2Title{
      display: block;
      width: 100%;
      height: 70px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background:  #202248;
      position: fixed;
      z-index: 850;
      cursor: pointer;
      .Navbar2MenuBox{
        width: 45px;
        font-size: 30px;
        margin-left: 10px;
        color: #f8b010;
      }
      .logo{
        width: 60px;
      }
      .search{
        font-size: 30px;
        width: 45px;
        margin-right: 10px;
        cursor: pointer;
        height: 40px;
        padding-right: 20px;
      }
    }
    .searchBox{
      position: fixed;
      top: 80px;
      left: 20px;
      width: 260px;
      z-index: 999;
      display: flex;
      ::v-deep{
        .el-autocomplete{
          flex: 1;
        }
        .el-input__inner{
          height: 35px;
          line-height: 35px;

          &::placeholder {
            color: #f5af0f;
            opacity: 1;
          }

          &::-webkit-input-placeholder {
            color: #f5af0f;
          }
        }
        .el-input__icon{
          line-height: 35px;
        }
        .el-input__prefix, .el-input__suffix{
          color: #73bbe7;
        }
        .el-button--primary{
          background: #f4b011;
          border: none;
        }

      }
      
    }

    .menuBox{
      animation: slideLeft 0.5s ease;
      position: fixed;
      top: 0;
      left: 0;
      width: 60%;
      height: 100%;
      background: #fff;
      z-index: 900;
      ::v-deep{
        // .el-menu-item{
        //   border-bottom: 1px solid #e6e6e6;
        // }
        .el-submenu{
          border-bottom: 1px solid #e6e6e6;
        }
      }
      @keyframes slideLeft {
        0% {
          left:-60%;
        }
        100% {
          left:0;
        }
      }
      .menuLogoBox{
        height: 70px;
        text-align: center;
        margin-top: 5px;
        >img{
          height: 60px;
        }
      }
    }

    .menuBottomBox{
      position: fixed;
      bottom: 0;
      left: 0;
      width: 60%;
      color: #666;
      font-size: 14px;
      // background: #fff;
      animation: slideDown 0.5s ease;
      @keyframes slideDown {
        0% {
          bottom:-50px;
        }
        100% {
          bottom:0;
        }
      }
      >div:nth-child(1){
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        border-bottom: 1px solid #e6e6e6;
        >div{
          margin-left: 5px;
        }
      }
      .menuBottomItem{
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 40px;
        >div{
          display: flex;
          align-items: center;
          .menuBottomIcon{
            color: #49abea;
            margin-right: 5px;
          }
        }
      }
    }
  }
  .appMainBox{
    padding-top: 70px;
  }
}

//PC
@media screen and (min-width: 1024px) {
  .NavbarBox1{
    display: block;      
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background: #202248;
    width: 100%;
    .navbar1Title{
      width: 80%;
      margin: 0 auto;
      padding-bottom: 15px;
      display: flex;
      align-items: center;
      max-width: 1300px;
      >img{
        width: 80px;
        cursor: pointer;
        margin-top: 5px;
      }
      >div:nth-child(2){
        flex: 1;
        .logoBox{
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0 auto;
          padding-top: 20px;

          >div:nth-child(1){
            flex: 1;
            text-align: center;
            .searchBox{
              width: 300px !important;
              .searchIcon{
                line-height: 27px;
                background: #f5af0f;
                border-radius: 27px;
                padding: 0 10px;
                color: #000;
                cursor: pointer;
              }
              .searchIcon:hover{
                line-height: 25px;
                padding: 0 9px;
                border: 1px solid #73bbe7;
              }
              ::v-deep{
                .el-input__inner{
                  height: 27px;
                  line-height: 27px;
                  border-radius: 27px;
                  width: 80%;

                  &::placeholder {
                    color: #f5af0f;
                    opacity: 1;
                  }

                  &::-webkit-input-placeholder {
                    color: #f5af0f;
                  }
                }
                .el-input__prefix{
                  left: 33px;
                }
                .el-input__icon{
                  line-height: 27px;
                  color: #cacaca;
                  font-size: 20px;
                }
                .el-input__prefix, .el-input__suffix{
                  color: #73bbe7;
                }



          }
        }
          }
          .logoRightBox{
            margin-right: 40px;
            text-align: end;
            display: flex;
            align-items: center;
            img{
              cursor: pointer;
              width: 22px;
            }
            i{
              color: #fff;
              font-size: 22px;
              cursor: pointer;
              margin-left: 10px;
            }
            i:hover{
              transform: scale(1.2);
              transition: all 0.3s;
            }
            .collImg{
              margin-left: 12px;
              width: 25px;
            }
            i{
              margin-right: 14px;
            }
            img:hover{
              transform: scale(1.2);
              transition: all 0.3s;
            }
          }

        }
      }
      .pcMenuBox{
        // height: 50px;
        // width: 80%;
        // max-width: 1300px;
        margin-top: 10px;
        color: #fff;
        // background: #fff;
        border-radius: 10px;
        .pcMenu{
          display: flex;
          justify-content: space-between;
          align-items: center;
          text-align: center;
          // width: 80%;
          // margin: 0 auto;
          font-size: 18px;
          // color: rgb(70,100,180);
          font-weight: 600;
          line-height: 30px;
          height: 30px;
          white-space: nowrap;
          overflow: hidden;
          >div{
            display: flex;
            align-items: center;
            cursor: pointer;
            border-radius: 30px;
            padding: 0 20px;
            >div{
              // margin-right: 5px;
            }
            i{
              font-weight: 800;
              margin: 7px 0 0 10px;
            }
          }
          .homeIcon{
            width: 20px;
            margin-right: 5px;
          }
          .hotIcon{
            width: 25px;
          }
          .actionMenu{
            color: #000;
            background: #7bbfea;
            border-radius: 30px;
            height: 30px;
          }
          .nowTitle{
            color: #f8b010;
            border-bottom: 4px solid #f8b010;
          }
        }
        .menuBodyBox{
          width: 65%;
          max-width: 1100px;
          // min-height: 300px;
          // max-height: 700px;
          height: 700px;
          // overflow-y: auto;
          color: #000;
          border-radius: 20px;
          //滚动条样式
          &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
          }
          &::-webkit-scrollbar-thumb {
            border-radius: 5px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #d9d9d9;
          }
          &::-webkit-scrollbar-track {
            border-radius: 5px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #fff;
          }
          background: #fff;
          border: 1px solid #d1d1d1;
          position: absolute;
          z-index: 999;
          display: flex;
          .menuBodyLeftBox{
            width: 280px;
            border-right: 1px solid #d1d1d1;
            // margin-top: 20px;
            // background: #e8dccb;
            .menuBodyLeftItem{
              display: flex;
              align-items: center;
              // justify-content: space-between;
              height: 50px;
              padding: 0 10px;
              // border-bottom: 1px solid #d1d1d1;
              cursor: pointer;
            }
            .menuBodyLeftItem:hover{
              background: #ccc;
            }
          }
          .menuBodyRightBox{
            flex: 1;
            .menuAccueliBox{                
              padding: 0 10px;
              .menuAccueliTitle{
                height: 40px;
                line-height: 40px;
                border-bottom: 1px solid #d1d1d1;
                color: #303030;
                font-size: 12px;
                cursor: pointer;
              }
              .menuAccueliTitle:hover{
                color: #73bbe7;
              }
              .menuAccueliItemBox{
                display: flex;
                flex-wrap: wrap;
                // display: inline-block;
                >div{
                  cursor: pointer;
                  width: 30%;
                  max-width: 220px;
                  margin-bottom: 10px;
                  // height: 320px;
                  // margin: 5px;
                    // margin: 0 auto;
                  // >div:nth-child(1){
                  //   overflow: hidden;
                  //   width: 100%;
                  //   // height: 180px;
                  //   img{
                  //     width: 100%;
                  //   }
                  //   img:hover{
                  //     transform: scale(1.2);
                  //     transition: all 0.5s;
                  //   }
                  // }
                  // >div:nth-child(2){
                  //   color: #666;
                  //   font-size: 12px;
                  //   font-weight: 600;
                  //   overflow: hidden;
                  //   text-overflow: ellipsis;
                  //   display: -webkit-box;
                  //   -webkit-box-orient: vertical;
                  //   -webkit-line-clamp: 2;
                  // }
                  // >div:nth-child(3){
                  //     max-width: 260px;
                  //   display: flex;
                  //   justify-content: space-between;
                  //   // padding: 5px 0;
                  //   font-size: 21px;
                  //   font-weight: 600;
                  //   >div:nth-child(1){
                  //     font-size: 18px;
                  //     color: #00946c;
                  //   }
                    
                  // }


                }

              }

            }
          }
          .menuBodyProductsBox{
            padding: 0 5px;
            min-width: 495px;
            flex: 1;
            >div{
              // text-align: center;
              // width: 25%;
                display: flex;
                height: 100%;
                flex-wrap: wrap;
                flex-direction: column;
                align-content: flex-start; /* 换行后从左边开始 */
                gap: 5px;
              >div{
                width: 200px;
                overflow: hidden;
                text-align: center;
                .menuBodyProductsTitle{
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  margin-right: 10px;
                  line-height: 36px;
                  cursor: pointer;
                  color: #3c3c3c;
                  font-size: 14px;
                  border-bottom: 1px solid #dbdce0;
                  font-weight: 700;
                }
                .menuBodyProductsPath{
                  width: 200px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  margin-right: 10px;
                  line-height: 28px;
                  color: #999;
                  font-size: 12px;
                  cursor: pointer;
                }
                .menuBodyProductsTitle:hover{
                  color: #73bbe7;
                }
                .menuBodyProductsPath:hover{
                  color: #73bbe7;
                }
              }

            }

          }
        }
      }
    }
  }
  .NavbarBox2{
    display: none;
  }
  .appMainBox{
    margin: 100px auto 0;
    // padding-top: 90px;
  }
}

</style>

<style lang="scss">
.my-autocomplete {
  .el-autocomplete-suggestion__wrap {
    max-height: 360px;
  }

  .el-autocomplete-suggestion li {
    padding: 8px 12px;
    line-height: normal;

    &:hover {
      background-color: #f5f7fa;
    }

    &:has(.hot-search-panel) {
      padding: 0;
      cursor: default;

      &:hover {
        background-color: transparent;
      }
    }
  }

  .hot-search-panel {
    width: 100%;
  }

  .hot-search-title {
    padding: 10px 14px;
    background: #f0f0f0;
    color: #f5af0f;
    font-size: 14px;
  }

  .hot-search-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px 14px 14px;
    background: #fff;
  }

  .hot-search-tag {
    padding: 4px 12px;
    border: 1px solid #f5af0f;
    border-radius: 4px;
    color: #f5af0f;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #f5af0f;
      color: #fff;
    }
  }

  .search-suggestion-item {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .search-suggestion-img {
    width: 44px;
    height: 44px;
    object-fit: contain;
    flex-shrink: 0;
    background: #f5f5f5;
    border: 1px solid #eee;
  }

  .search-suggestion-name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    color: #333;
  }
}
</style>
